import { render, staticRenderFns } from "./CalendarReferences.vue?vue&type=template&id=2b5228d4&scoped=true"
import script from "./CalendarReferences.vue?vue&type=script&lang=js"
export * from "./CalendarReferences.vue?vue&type=script&lang=js"
import style0 from "./CalendarReferences.vue?vue&type=style&index=0&id=2b5228d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5228d4",
  null
  
)

export default component.exports